import React from 'react';
import NavBar from "../components/NavBar";
import './services.css'; 
import leaderIllustration from '../assets/leaderIllustration.png'; 
import consultingImage from '../assets/consulting_hands.png';
import img1 from '../assets/img1.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';
import icfCoachImage from '../assets/ICF Coach.png';
import oneOnOneCoachingImage from '../assets/One-on-one coaching.png';
import womenLeadershipImage from '../assets/Women Leadership.png';

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";

const interventions = [
  // Column 1
  "Emotional Intelligence (EI) and Leadership",
  "Transformational Leadership",
  "Adaptive Leadership",
  "Strategic Thinking and Decision Making",
  "Coaching and Mentoring for Leadership",
  "Diversity, Equity, and Inclusion (DEI) Leadership",
  "Leading Remote and Hybrid Teams",
  "Conflict Resolution and Negotiation",
  
  // Column 2
  "Leading with Personal Effectiveness",
  "Change Management",
  "Leadership Presence and Communication",
  "High-Performance Team Leadership",
  "Innovation and Creative Leadership",
  "Resilience and Well-being for Leaders",
  "Digital Leadership",
  "Ethical Leadership",
];


const advisorySteps = [
  {
    title: "Review",
    description: "Deep-dive assessment of your existing Processes, Tools, Metrics, Assets, and Automation (BOTs) to identify optimization opportunities",
    icon: ""
  },
  {
    title: "Compare & Benchmark",
    description: "Evaluate your current state against Industry Best Practices and Market Leaders to quantify performance gaps",
    icon: ""
  },
  {
    title: "Educate & Advise",
    description: "Provide clear insights, gap analysis, and actionable recommendations tailored to your business objectives and constraints",
    icon: ""
  },
  {
    title: "Implement Change",
    description: "Partner with your teams to drive process improvements, automation enhancement, and performance optimization initiatives",
    icon: ""
  },
];
const mainCategories = [
  {
    title: "AI & Machine Learning",
    details: "Supervised/Unsupervised Learning, Neural Networks, NLP, Deep Learning, AI in Business Applications"
  },
  {
    title: "Cloud Computing",
    details: "Cloud Models (IaaS, PaaS, SaaS), Major Providers (AWS, Azure, Google Cloud), Cloud Security, DevOps Integration"
  },
  {
    title: "Cybersecurity",
    details: "Threats & Vulnerabilities, Network Security, Encryption, IAM, Incident Response"
  },
  {
    title: "Data Analytics",
    details: "Data Visualization, Business Intelligence, Reporting Dashboards, Statistical Analysis, Data-Driven Decision Making"
  },
  {
    title: "Software Development",
    details: "Agile Practices, Full-Stack Development, API Design, Microservices, Testing and Deployment"
  },
  {
    title: "DevOps & Automation",
    details: "CI/CD Pipelines, Infrastructure as Code, Containers, Monitoring, Release Automation"
  },
];
const talentCategories = [
  {
    title: "Advanced Sourcing Techniques",
    description: "Leveraging market intelligence, cutting-edge tools, and deep understanding of industry needs to identify and attract top-tier talent in competitive markets.",
    icon: "" 
  },
  {
    title: "Critical Technical Roles",
    description: "Specialized expertise in sourcing professionals for software development, cybersecurity, data science, cloud computing, AI/ML, and emerging technology domains.",
    icon: "" 
  },
  {
    title: "Operational Excellence",
    description: "Comprehensive recruitment for operational roles including supply chain management, business operations, process management, and quality assurance positions.",
    icon: "" 
  },
  {
    title: "Executive Leadership",
    description: "Strategic placement of mid-level managers to C-suite executives who drive transformation, innovation, and sustainable growth across technology and operations divisions.",
    icon: "" 
  },
];
const cloudLabFeatures = [
  {
    title: "Enterprise-Grade Security",
    description: "Built with comprehensive security protocols including advanced access controls, end-to-end encryption, and continuous monitoring to ensure complete protection of all training activities and sensitive data.",
    icon: "" 
  },
  {
    title: "Global Accessibility",
    description: "Accessible from anywhere worldwide, enabling seamless engagement with training materials and hands-on exercises without geographical constraints or infrastructure limitations.",
    icon: "" 
  },
 
  {
    title: "Real-Time Collaboration",
    description: "Advanced collaborative features enable learners to work together in real-time, share resources effectively, and engage in group projects regardless of their physical location or time zone.",
    icon: "" 
  },
  {
    title: "Interactive Learning Environment",
    description: "Each lab provides a fully interactive, practical environment where participants can experiment with cutting-edge technologies, apply theoretical knowledge, and explore diverse real-world use cases.",
    icon: "" 
  },
];
const poshTrainingPoints = [
  "Org-wide POSH Awareness Workshops",
  "POSH training for Managers & Leaders",
  "Internal Committee(IC) Training & Certification",
  "Advance IC Capability Building Workshops",
  "Policy Design & Review Support",
  "POSH Case Management & Advisory Support",
  "Bystander Intervention & Safe Workplace Programs",
];
const deiTrainingPoints = [
  "DEI Awareness & Sensitization",
  "Unconscious bias & inclusive decision-making",
  "Inclusive Leadership Development",
  "Gender Sensitization",
  "Building Psychological Safety",
  "Cross-cultural adaptability",
  "Customised DEI Interventions",
];
const womenLeadershipPoints = [
  "Accelerating high-potential internal talent",
  "Maximized Human Capital ROI",
  "Optimized Succession Readiness",
  "Cultural Transformation Equity",
  "Strategic Stakeholder Influence",
  "Strengthening staff align to cross-functional goals",
];
const womenLeadershipDevelopmentPoints = [
  "Authority & Executive Presence",
  "Strategic Advocacy & Negotiation",
  "Financial Acumen for the Boardroom",
  "Resilience & Cognitive Agility",
  "Leading Diverse, Inclusive Teams",
  "Conflict Synthesis & Resolution",
  "Digital Strategy & AI Leadership",
];
const coachingProgramPoints = [
  "Vision Alignment & Strategic Execution",
  "Dismantling Critical Cognitive Blind Spots",
  "Deep Work Protocols for C-Suite Focus",
  "Mastering High-Stakes Board Negotiations",
  "Lateral Thinking for Bottleneck Removal",
  "Advanced EQ for Hyper-Growth Resilience",
  "Rapid, Data-Driven Choices in Ambiguity",
  "Elite Team Building & Attrition Control",
  "Measuring the ROI of Leadership Impact",
];
const oneOnOneCoachingPoints = [
  "Maker to Manager Transition",
  "Emotional Intelligence & Empathy",
  "Delegation & Accountability",
  "Lateral Problem Solving",
  "Navigating Difficult Talks",
  "People Analytics & Data",
  "Aligning Goals with Vision",
  "Building Psychological Safety",
  "Deep Work & Productivity",
];
const healthcareTrainings = [
  {
    id: '01',
    title: "Revenue Cycle Management (RCM)",
    description: "End-to-end RCM processes including patient registration, insurance verification, charge capture, claims submission, denial management, and AR optimization"
  },
  {
    id: '02',
    title: "Healthcare Compliance",
    description: "HIPAA training, fraud prevention, ICD-10 and CPT coding practices, ensuring regulatory compliance and data security"
  },
  {
    id: '03',
    title: "Technology & Analytics",
    description: "RPA automation, data analytics for RCM optimization, leveraging technology for operational efficiency"
  },
  {
    id: '04',
    title: "Process Excellence",
    description: "Lean Six Sigma methodologies, quality assurance, and continuous improvement in healthcare operations"
  },
  {
    id: '05',
    title: "Industry Knowledge",
    description: "Healthcare insurance fundamentals, payer systems (Medicare, Medicaid, commercial), policy updates and trends"
  },
];
const financeTrainings = [
  {
    id: '01',
    title: "Banking Operations",
    description: "Core banking operations, cash management, trade finance, and digital banking transformation strategies"
  },
  {
    id: '02',
    title: "Regulatory Compliance",
    description: "AML programs, Basel III, Dodd-Frank, consumer protection laws, fraud detection and prevention methodologies"
  },
  {
    id: '03',
    title: "Financial Products",
    description: "Loan underwriting, investment management, wealth advisory services, and modern payment systems"
  },
  {
    id: '04',
    title: "Digital Transformation",
    description: "Banking software systems, fintech innovations, cybersecurity protocols, and digital customer experience"
  },
  {
    id: '05',
    title: "Risk & Analysis",
    description: "Credit risk management, financial analysis, capital adequacy, internal auditing, and risk-based pricing models"
  },
];
const approaches = [
  {
    title: "Enterprise-First Approach",
    description: "Our Enterprise First approach ensures every training intervention is aligned with organizational goals. We design solutions that address real business challenges, enhance workforce capability, and create measurable impact across teams and functions."
  },
  {
    title: "Technology-Driven Innovation",
    description: "We believe technology is a powerful enabler of human potential. By combining innovative learning technologies with expert facilitation, we create transformative development experiences that equip employees and leaders to thrive in an ever-evolving digital world."
  },
  {
    title: "Strategic Industry Partnerships",
    description: "Collaborating with leading technology companies and industry experts to deliver cutting-edge content that maintains credibility and relevance in rapidly evolving markets."
  },
  {
    title: "Customized Solutions",
    description: "Training programs designed to align with organizational goals, ensuring cultural and contextual relevance. Flexible delivery through blended learning approaches combining instructor-led training with digital tools."
  },
  {
    title: "Scalable Learning Models",
    description: "Comprehensive range of formats including self-paced content, live virtual classes, and hybrid options to accommodate diverse learner preferences and organizational structures."
  },
  {
    title: "Workforce Transformation Focus",
    description: "Leadership, behavioral, and technical training programs that drive measurable business outcomes through innovative methodologies like gamification and project-based learning."
  },
];
const detailedTopics = [
  "Blockchain: Distributed Ledgers, Consensus, Smart Contracts, Cryptocurrencies, Security",
  "Internet of Things (IoT): Devices, Communication Protocols, IoT Architecture, Security, Business Use Cases",
  "Data Science & Big Data: Data Analysis, Hadoop, Spark, Visualization Tools, Data Ethics",
  "5G & Edge Computing: 5G Architecture, Edge vs. Cloud, Autonomous Vehicles, Smart Cities",
  "AR & VR: AR/VR Fundamentals, Development Platforms, Business Applications",
  "Robotic Process Automation (RPA): RPA Basics, UiPath, Automation Anywhere, AI Integration",
  "Quantum Computing: Quantum Principles, Algorithms, Programming (Qiskit), Cryptography Applications",
  "DevOps & Automation: CI/CD, Jenkins, Docker, Kubernetes, Infrastructure as Code, Monitoring",
  "Software Development: Agile & Scrum, Microservices, Serverless Computing, API Development",
]



const LeadershipInterventions = () => {
  const midIndex = Math.ceil(interventions.length / 2);
  const column1 = interventions.slice(0, midIndex);
  const column2 = interventions.slice(midIndex);

  return (
    <div className="interventions-section-container">
      <div className="illustration-column">
        <img src={leaderIllustration} alt="Businesswoman illustration symbolizing leadership and growth" className="leader-illustration" />
      </div>
      <div className="content-column">
        <header className="content-header">
           <h1 className="main-title leadership-title scroll-section" id='leader'>Leadership Development Interventions</h1>
        </header>
        <p className="intro-text"> Comprehensive leadership development programs   designed to cultivate exceptional leaders who can navigate complex business challenges and drive organizational transformation in today's dynamic environment. </p>
        <div className="interventions-list-wrapper">
          <ul className="interventions-list">
            {column1.map((item, index) => (
              <li key={`col1-${index}`}>{item}</li>
            ))}
          </ul>
          <ul className="interventions-list">
            {column2.map((item, index) => (
              <li key={`col2-${index}`}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
const AdvisoryConsulting = () => {
  return (
    <div className="advisory-consulting-container">
      <div className="advisory-image-column">
        <img src={consultingImage} alt="Business professional analyzing chart data" className="consulting-image" />
      </div>
      <div className="advisory-content-column">
        <header className="advisory-header">
          <h1 className="advisory-title" id='Advisory'>Advisory & Consulting</h1>
          <h2 className="advisory-subtitle">Optimizing for Excellence: Review, Benchmark, Transform</h2>
        </header>
        <p className="aadvisory-intro-text"> Our comprehensive advisory approach delivers measurable improvements through systematic analysis and strategic implementation, ensuring your organization achieves sustainable competitive advantage. </p>
        <div className="advisory-steps-wrapper">
          {advisorySteps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-icon-container">
                <span className="step-icon">{step.icon}</span>
                {index < advisorySteps.length - 1 && <div className="step-line"></div>}
              </div>
              <div className="step-text">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="advisory-outcome"> Outcome: <span className="outcome-tag">Enhanced Efficiency</span> | <span className="outcome-tag">Competitive Advantage</span> | <span className="outcome-tag">Future-Ready Operations</span> </p>
      </div>
    </div>
  );
};

const PoshWorkplaceSection = () => {
  return (
    <div className="service-outline-card posh-section-container">
      <h2 className="posh-section-title">Prevention Of Sexual Harassment (POSH) Trainings</h2>
      <div className="posh-content-column">
        <p className="posh-intro-text">
          At RTS TechSol, we believe that highly-collaborative workforce is a long-term product of ethical workplaces and psychological safety. Our POSH solutions ensure organizations are legally compliant while building a culture incorporated with dignity and respect.
        </p>
        <h2 className="posh-list-heading">We offer different chapters of POSH training like:</h2>
        <ul className="posh-points-list">
          {poshTrainingPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <div className="posh-image-column">
        <img src={img1} alt="Collaborative workplace meeting" className="posh-image" />
      </div>
      <p className="posh-note-text">
        Our POSH solutions ensure organizations are legally compliant while building a culture of dignity and respect.
      </p>
      <div className="posh-outcome-row">
        <strong>Outcomes:</strong> Better Collaboration | Improved Compliance | Highly Inclusive Culture
      </div>
    </div>
  );
};

const DeiWorkplaceSection = () => {
  return (
    <div className="service-outline-card posh-section-container dei-section-container">
      <h2 className="posh-section-title">Diversity, Equity & Inclusion (DEI) Trainings</h2>
      <div className="posh-content-column">
        <p className="posh-intro-text">
          At RTS TechSol, we believe that high-performing organizations are built on the foundation of inclusive cultures and psychological safety. Our DEI interventions are designed to create awareness, build capability, and drive sustainable culture transformation.
        </p>
        <h2 className="posh-list-heading">We offer different modules in DEI training such as:</h2>
        <ul className="posh-points-list">
          {deiTrainingPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <div className="posh-image-column">
        <img src={img2} alt="DEI strategy workshop" className="posh-image" />
      </div>
      <p className="dei-note-text">
        Our DEI interventions are designed to create awareness, build capability, and drive sustainable culture transformation.
      </p>
    </div>
  );
};

const WomenLeadershipSection = () => {
  return (
    <div className="service-outline-card women-leadership-section">
      <header className="women-leadership-header">
        <h2 className="women-leadership-title">Women Leadership</h2>
        <p className="women-leadership-intro">
          Women don’t just transform the potential; they redefine excellence. Our seasoned experts empower women to
          lead with vision and resilience as well convert their expertise into making everlasting impact.
        </p>
      </header>
      <div className="women-leadership-content">
        <div className="women-leadership-points">
          <ul className="women-leadership-list">
            {womenLeadershipPoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
        <div className="women-leadership-image-wrap">
          <img
            src={img3}
            alt="Women leadership development session"
            className="women-leadership-image"
          />
        </div>
      </div>
      <div className="women-leadership-note">
        Our Women Leadership sessions are crafted to instill them leading with high EQ, strategic gravitas, and
        measurable business impact.
      </div>
    </div>
  );
};

const WomenLeadershipDevelopmentSolutionsSection = () => {
  return (
    <div className="service-outline-card women-leadership-section">
      <header className="women-leadership-header">
        <h2 className="women-leadership-title">Women Leadership Development Solutions</h2>
        <p className="women-leadership-intro">
          Built by veterans, our unapologetic bias empowers women to break mindset barriers to restrict to boardrooms or
          bay and have a sense of belongingness and pie of share in the equity in the corporation. We don't just coach;
          we elevate leaders.
        </p>
      </header>
      <div className="women-leadership-content">
        <div className="women-leadership-points">
          <ul className="women-leadership-list">
            {womenLeadershipDevelopmentPoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
        <div className="women-leadership-image-wrap">
          <img
            src={womenLeadershipImage}
            alt="Women leadership development solutions session"
            className="women-leadership-image"
          />
          <div className="card-image-divider" aria-hidden="true"></div>
        </div>
      </div>
      <div className="women-leadership-note">
        Our Women Leadership Development Solutions help leaders build authority, confidence, and measurable impact.
      </div>
    </div>
  );
};

const CoachingProgramsSection = () => {
  return (
    <div className="service-outline-card coaching-section-container">
      <header className="coaching-header">
        <h2 className="coaching-title">Certified Coaches Training & Coaching Programs</h2>
        <p className="coaching-intro-text">
          Top talent needs an objective mirror. Our ICF-ACC coaching destroys blind spots,
          accelerates growth, and builds sovereign industry authority.
        </p>
      </header>
      <div className="coaching-content-row">
        <div className="coaching-points-column">
          <ul className="coaching-points-list">
            {coachingProgramPoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
        <div className="coaching-image-column">
          <img
            src={icfCoachImage}
            alt="Business coaching and leadership development session"
            className="coaching-image"
          />
          <div className="card-image-divider" aria-hidden="true"></div>
        </div>
      </div>
    </div>
  );
};

const OneOnOneCoachingSection = () => {
  return (
    <div className="service-outline-card coaching-section-container">
      <header className="coaching-header">
        <h2 className="coaching-title">One-on-one Coaching for First-Time Managers, Leaders and Emerging Talent</h2>
        <p className="coaching-intro-text">
          Don't let new managers stumble or any other leader fumble. Our expert 1-on-1 coaching
          transforms raw or disoriented talent into resilient leaders who drive results and scale your vision.
        </p>
      </header>
      <div className="coaching-content-row">
        <div className="coaching-points-column">
          <ul className="coaching-points-list">
            {oneOnOneCoachingPoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
        <div className="coaching-image-column">
          <img
            src={oneOnOneCoachingImage}
            alt="One-on-one coaching session for emerging leaders"
            className="coaching-image"
          />
          <div className="card-image-divider" aria-hidden="true"></div>
        </div>
      </div>
    </div>
  );
};

const TechnologyTrainings = () => {
  return (
    <div className="technology-section-container">
      <header className="tech-header">
        <h1 className="tech-main-title" id='Train'>Technology Trainings</h1>
        <p className="tech-intro-text"> Cutting-edge technology training programs designed to keep teams abreast of industry trends and equipped with the latest skills for digital transformation success. </p>
      </header>
      <div className="category-cards-wrapper">
        {mainCategories.map((category, index) => (
          <div key={index} className="category-card">
            <h2 className="category-title">{category.title}</h2>
            <p className="category-details">{category.details}</p>
          </div>
        ))}
      </div>
      <div className="detailed-content-wrapper">
        <div className="topics-list-column">
          <ul className="detailed-topics-list">
            {detailedTopics.map((topic, index) => (
              <li key={index}>{topic}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
const TalentAcquisition = () => {
  return (
    <div className="talent-acquisition-container">
      <header className="talent-header">
        <h1 className="talent-main-title" id='Talent'>Talent Acquisition</h1>
        <p className="talent-intro-text"> Strategic talent acquisition services that connect you with exceptional professionals who drive innovation, growth, and competitive advantage across technology and operations functions. </p>
      </header>
      <div className="categories-grid">
        {talentCategories.map((category, index) => (
          <div key={index} className="category-item">
            <div className="category-icon">{category.icon}</div>
            <div className="category-text">
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
            </div>
          </div>
        ))}
      </div>
     
    </div>
  );
};
const DomainSpecificTrainings = () => {
  return (
    <div className="domain-trainings-container">
      <header className="domain-header">
         <h1 className="domain-main-title" id='Domain'>Domain-Specific Training Solutions</h1>
        <p className="domain-intro-text"> Specialized training programs tailored for healthcare and banking & finance sectors, addressing industry-specific challenges, regulatory requirements, and operational excellence standards. </p>
      </header>
      <div className="training-content-wrapper">
        <div className="domain-column healthcare-column">
          <h2 className="domain-heading">Healthcare Domain Trainings</h2>
          {healthcareTrainings.map((item) => (
            <div key={item.id} className="training-item">
              <span className="item-number">{item.id}</span>
              <h3 className="item-title">{item.title}</h3>
              <p className="item-description">{item.description}</p>
            </div>
          ))}
        </div>
        <div className="domain-column finance-column">
          <h2 className="domain-heading">Banking & Finance Domain Trainings</h2>
          {financeTrainings.map((item) => (
            <div key={item.id} className="training-item">
              <span className="item-number">{item.id}</span>
              <h3 className="item-title">{item.title}</h3>
              <p className="item-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};
const AboutRTS = () => {
  return (
    <div className="about-rts-container">
      <header className="about-rts-header">
        <h1 className="about-rts-title" id="TECH">RTS TECHSOL: Transforming Enterprise Talent</h1>
        <p className="about-rts-intro-text"> RTS TECHSOL stands at the forefront of enterprise technology training, delivering comprehensive solutions that bridge the critical gap between emerging technologies and workforce readiness. We empower organizations to thrive in the digital era through strategic training initiatives. </p>
      </header>
      <div className="approaches-grid">
        {approaches.map((approach, index) => (
          <div key={index} className="approach-card">
            <h3 className="approach-title">{approach.title}</h3>
            <p className="approach-description">{approach.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
const CloudLabsSection = () => {
  return (
    <div className="cloud-labs-container">
      <header className="cloud-labs-header">
        <h1 className="cloud-labs-title" id='Cloud'>Cloud Labs for Technology Training Excellence</h1>
        <p className="cloud-labs-intro-text"> Our state-of-the-art cloud laboratory infrastructure revolutionizes technology training by providing learners with unlimited access to real-world environments. These labs eliminate traditional barriers to hands-on learning, enabling organizations to accelerate skill development at scale. </p>
      </header>
      <div className="features-grid">
        {cloudLabFeatures.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
      
    </div>
  );
};
const ServicesPage = () => {

  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [hash]);
    return (
        <>
            <SEO
                title="Services"
                description="Explore RTS Techsol services including leadership development, advisory consulting, technology trainings, domain-specific training, talent acquisition, and cloud labs."
                path="/services"
            />
            <NavBar /> 
            <AboutRTS />
            <LeadershipInterventions />
            <DeiWorkplaceSection />
            <PoshWorkplaceSection />
            <WomenLeadershipSection />
            <WomenLeadershipDevelopmentSolutionsSection />
            <CoachingProgramsSection />
            <OneOnOneCoachingSection />
            <AdvisoryConsulting />
            <TechnologyTrainings />
            <DomainSpecificTrainings />
            <TalentAcquisition />
            <CloudLabsSection />
        </>
    )
}

export default ServicesPage;

